import { Schema as S } from "effect";
import { defineMessageUnion } from "foldkit/message";
import {
	createBillingPortal,
	createCheckout,
	getSubscription,
} from "../../api/commands/billing";
const tagged = { asOf: S.Option(S.String), generation: S.Number };
export const Message = defineMessageUnion({
	CompletedFetch: { ...tagged, result: getSubscription.Result },
	ClickedSubscribe: {},
	ClickedPortal: {},
	CompletedCheckout: { ...tagged, result: createCheckout.Result },
	CompletedPortal: { ...tagged, result: createBillingPortal.Result },
	CompletedRedirect: {},
});
export type Message = typeof Message.Type;
